module.exports = __webpack_public_path__ + "img/image45.f086c4d6.png";